<div>
  <div>
    <div style="display: flex; flex-direction: row; align-items: flex-end; gap: 15px;">
      <app-date style="width: auto; flex: 0 0 auto; margin-right: 0;" [(ngModel)]="this.recurringSchedule.firstChargeDate" (onChanged)="handleFormChanged()" [label]="'First Charge Date'"></app-date>
      <app-textbox style="width: auto; flex: 0 0 auto; margin-right: 0;" [width]="'60px'" [label]="'Charge Every'" [type]="inputTextModes.Numeric" [(ngModel)]="recurringSchedule.periodCount" (ngModelChange)="handleFormChanged()"></app-textbox>
      <app-selectbox [label]="'&nbsp;'" [options]="frequencyTypeOptions" [(ngModel)]="recurringSchedule.period" (onChanged)="handleFormChanged()"></app-selectbox>
    </div>

    <div class="form-input-container" style="margin-bottom: 10px;">
      <label>Charge until</label>
    </div>

    <div style="width: 100%; display: inline-flex; flex-wrap: nowrap; gap: 0.5rem">
      <app-radio-group [options]="chargeUntilOptions" [(ngModel)]="recurringSchedule.chargeUntil" (onChanged)="handleFormChanged()"></app-radio-group>
    </div>

    <div [hidden]="this.recurringSchedule.chargeUntil != 'date'">
      <app-date name="finalChargeDate" [label]="'Last Charge Date'" [(ngModel)]="recurringSchedule.finalChargeDate" (onChanged)="handleFormChanged()"></app-date>
    </div>

    <div [hidden]="this.recurringSchedule.chargeUntil != 'number'">
      <app-textbox [label]="'Total Payments'" [width]="'60px'" [type]="inputTextModes.Numeric" [(ngModel)]="recurringSchedule.numberOfCharges" (ngModelChange)="handleFormChanged()"></app-textbox>
    </div>

    <div style="width: 100%; display: inline-flex; flex-wrap: nowrap; gap: 0.5rem" [hidden]="this.suggestedEndDateBefore == undefined || this.suggestedEndDateAfter == undefined">
      <div style="border: 1px solid #dddddd; border-radius: 4px; padding: 6px 4px 7px 4px;">
        <div>
          The date you selected falls on a non-payment day. Select one of these:
        </div>
        <div>
          <input
            type="button"
            class="button button_secondary button_var_2 button_right-spacing"
            value="{{ this.suggestedEndDateBeforeToDisplay }}"
            (click)="useSuggestedEndDateBefore()"
          />
          <input
            type="button"
            class="button button_secondary button_var_2"
            value="{{ this.suggestedEndDateAfterToDisplay }}"
            (click)="useSuggestedEndDateAfter()"
          />
        </div>
      </div>
    </div>

    <div
      class="flex-container"
      style="flex-direction: row; gap: 10px"
      [hidden]="this.recurringSchedule.period == undefined"
    >
      <div class="column" style="flex: 1">
      </div>
    </div>
  </div>
</div>
